import { useSession } from '@sdk/session/SessionContext';

import { ConversationMembersField } from '@web/conversations/ComposeConversation/ConversationMembersField/ConversationMembersField';
import { ConversationNameField } from '@web/conversations/ComposeConversation/ConversationNameField/ConversationNameField';
import { ConversationRestrictionsField } from '@web/conversations/ComposeConversation/ConversationRestrictionsField/ConversationRestrictionsField';
import { Conversation } from '@web/conversations/types/Conversation';
import {
  ConversationFormWrapper,
  Separator,
} from '@web/conversations/ComposeConversation/composeConversation.styles';
import { ConversationEditHeader } from '@web/conversations/ConversationEdit/ConversationEditHeader/ConversationEditHeader';
import { ComposeConversationActions } from '@web/conversations/ComposeConversation/ComposeConversationActions/ComposeConversationActions';

import { useConversationEdit } from './conversationEdit.hooks';

type Props = { conversation: Conversation };

export const ConversationEditForm = ({ conversation }: Props) => {
  const {
    fields,
    cancel,
    isDirty,
    submit: formSubmit,
    isFormValid,
    submitErrors,
  } = useConversationEdit({
    conversation,
  });
  const { currentUser } = useSession();

  return (
    <ConversationFormWrapper>
      <ConversationEditHeader />
      <ConversationNameField name={fields.name} />
      <ConversationMembersField members={fields.members} />

      {currentUser.isManager && (
        <>
          <Separator />

          <ConversationRestrictionsField
            members={fields.members}
            restricted={fields.restricted}
            restrictedToUsers={fields.restrictedToUsers}
            submitErrors={submitErrors}
          />
        </>
      )}

      <ComposeConversationActions
        onCancel={cancel}
        onSubmit={formSubmit}
        isFormDirty={isDirty}
        isFormValid={isFormValid}
      />
    </ConversationFormWrapper>
  );
};
